import ViewAs from '../ViewAs';

import { PROFILE_MENU_ID } from './header.constants';
import { HeaderProfileMenu } from './HeaderProfileMenu';
import { ProfileMenuButton } from './ProfileMenuButton';
import { useProfileMenu } from './useProfileMenu';

export const ProfileMenuControl = (): JSX.Element => {
  const { userName, menuAnchor, dialog, items, openMenu, close, closeViewAs } = useProfileMenu();

  return (
    <>
      <ProfileMenuButton
        menuId={PROFILE_MENU_ID}
        expanded={menuAnchor !== null}
        userName={userName}
        onOpen={openMenu}
      />
      <HeaderProfileMenu id={PROFILE_MENU_ID} anchorEl={menuAnchor} items={items} onClose={close} />
      {dialog === 'viewAs' && <ViewAs open handleClose={closeViewAs} />}
    </>
  );
};
